import {useCallback, useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {Button, Input} from "../components/atoms";
import {PiCheckCircleFill, PiConfetti, PiShieldWarningBold, PiWarningCircleFill, PiSpinner} from "react-icons/pi";
import defaultLogo from "../assets/imgs/wargos.svg";

const baseURL = 'https://api5.wargos.cloud'

const getCustomerName = (customerData) => {
  return [customerData?.firstName, customerData?.lastName1]
    .filter(Boolean)
    .join(' ')
    .trim();
}

const LoginPage = () => {
  const navigate = useNavigate();

  const salaId = localStorage.getItem("s")
  const storedLogo = localStorage.getItem("logo");
  const logo = storedLogo && storedLogo !== ""
    ? storedLogo
    : defaultLogo;
  const documentLs = localStorage.getItem("document")
  const [customerName, setCustomerName] = useState(localStorage.getItem("name") || '')

  const [response, setResponse] = useState('')
  const [document, setDocument] = useState('')
  const [success, setSuccess] = useState(false);
  const [loadingQr, setLoadingQr] = useState(false);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (salaId === null || salaId === undefined || salaId === '') {
      navigate("/")
    }
  }, [salaId, navigate]);

  const logout = () => {
    localStorage.removeItem("document")
    localStorage.removeItem("name")
    localStorage.removeItem("customerId")
    setCustomerName('')
    setDocument('')
    setResponse('')
  }

  const loginQr = useCallback((doc) => {
    setLoadingQr(true)
    const body = {
      document: doc,
      code: searchParams.get('code'),
      salaId: salaId
    }
    axios.post(baseURL + '/xcustomerapp/qr-login-simple', body).then((response) => {
      localStorage.setItem("document", doc)
      const fullName = getCustomerName(response?.data)
      if (fullName) {
        localStorage.setItem("name", fullName)
      } else {
        localStorage.removeItem("name")
      }
      setCustomerName(fullName)
      if (response?.data?.customerId !== undefined && response?.data?.customerId !== null) {
        localStorage.setItem("customerId", String(response.data.customerId))
      } else {
        localStorage.removeItem("customerId")
      }
      setSuccess(true)
      setResponse('')
    }).catch((error) => {
      const baseMessage = error?.response?.data?.message || 'Ocurrió un error'
      const apiCode = error?.response?.data?.code
      const statusCode = error?.response?.status
      const suffixParts = []
      if (apiCode) suffixParts.push(`Código: ${apiCode}`)
      if (statusCode) suffixParts.push(`${statusCode}`)
      const message = suffixParts.length ? `${baseMessage} (${suffixParts.join(' - ')})` : baseMessage
      setResponse(message)
      setSuccess(false)
    }).finally(() => {
      setLoadingQr(false);
    });
  }, [salaId, searchParams])

  useEffect(() => {
    if (documentLs !== null && documentLs !== undefined && documentLs !== '') {
      setDocument(documentLs)
      loginQr(documentLs);
    }
  }, [documentLs, loginQr]);

  const documentIsValid = () => {
    return documentLs !== null && documentLs !== undefined && documentLs !== ''
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (document) {
      loginQr(document);
    } else {
      console.error('Documento no válido');
    }
  }

  return (
    <div className="w-full h-[100vh] flex flex-col items-center justify-center p-8 gap-6">
      <img src={logo} alt="logo" className="max-w-[250px] min-w-[160px] max-h-[200px]" />
      {!documentIsValid() ?
        <form onSubmit={handleSubmit} className="flex flex-col items-center w-full gap-4">
          <div className="flex flex-col items-center w-full gap-1">
            <span className="">Ingrese su documento</span>
            <Input type="number" className='text-xl text-center' value={document} required
              onChange={(e) => setDocument(e.target.value)} />
          </div>
          <Button type="submit" className='w-full' disabled={loadingQr}>{loadingQr ? 'Cargando' : 'Ingresar'}</Button>
          {response !== '' && !loadingQr &&
            <div className="flex flex-col items-center gap-2">
              <PiWarningCircleFill size={40} className="text-amber-600" />
              <span className="text-sm text-center">{response}</span>
            </div>
          }
        </form>
        :
        <div className="flex flex-col items-center w-full gap-4">
          {loadingQr ?
            <div className="flex flex-col items-center gap-2">
              <PiSpinner size={60} className="animate-spin" />
              <div className="flex flex-col items-center gap-2 text-center">
                <span className="text-[16px]">Cargando</span>
              </div>
            </div>
            :
            (success ?
              <>
                <div className="flex flex-row gap-1">
                  <span>Bienvenido,</span>
                  <strong>{customerName}</strong>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <PiCheckCircleFill size={100} className="text-green-600" />
                  <div className="flex flex-row items-center gap-2 text-center">
                    <span>Sesión iniciada</span>
                    <PiConfetti size={20} />
                  </div>
                </div>
                <Button onClick={() => navigate('/')}>Ver cupones</Button>
              </>
              :
              <div className="flex flex-col items-center gap-2">
                <PiShieldWarningBold size={100} className="text-amber-600" />
                <div className="flex flex-col items-center gap-2 text-center">
                  <span>{response}</span>
                  <strong>{'Documento: ' + document}</strong>
                  {/*<strong>{'QR: ' + searchParams.get('code')}</strong>*/}

                  <Button onClick={() => loginQr(document)}>Reintentar</Button>
                </div>
              </div>
            )
          }
          <Button variant='outline' onClick={logout} className='mt-32'>Cambiar de documento</Button>
        </div>
      }
    </div>
  )
}

export default LoginPage
